import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

export const imageUrl = (src) =>
  src && src.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(", ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
